// ICONSCOUT React Unicons Line UIL
import UilApps from '@iconscout/react-unicons/icons/uil-apps';
import UilAnalysis from '@iconscout/react-unicons/icons/uil-analysis';
import UilAnalytics from '@iconscout/react-unicons/icons/uil-analytics';
import UilArchive from '@iconscout/react-unicons/icons/uil-archive';
import UilArrowDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilArrowLeft from '@iconscout/react-unicons/icons/uil-angle-left';
import UilArrowRight from '@iconscout/react-unicons/icons/uil-angle-right';
import UilArrowUp from '@iconscout/react-unicons/icons/uil-angle-up';
import UilAsterisk from '@iconscout/react-unicons/icons/uil-asterisk';
import UilAward from '@iconscout/react-unicons/icons/uil-award';
import UilBars from '@iconscout/react-unicons/icons/uil-bars';
import UilBolt from '@iconscout/react-unicons/icons/uil-bolt';
import UilBook from '@iconscout/react-unicons/icons/uil-book';
import UilBookmark from '@iconscout/react-unicons/icons/uil-bookmark';
// import UilCalendar from '@iconscout/react-unicons/icons/uil-calendar';
import UilCalendarSlash from '@iconscout/react-unicons/icons/uil-calendar-slash';
import UilCircle from '@iconscout/react-unicons/icons/uil-circle';
import UilChartDown from '@iconscout/react-unicons/icons/uil-chart-down';
import UilCheckCircle from '@iconscout/react-unicons/icons/uil-check-circle';
import UilClock from '@iconscout/react-unicons/icons/uil-clock';
import UilCrosshair from '@iconscout/react-unicons/icons/uil-crosshair';
import UilCrosshairs from '@iconscout/react-unicons/icons/uil-crosshairs';
import UilMinusCircle from '@iconscout/react-unicons/icons/uil-minus-circle';
import UilCheck from '@iconscout/react-unicons/icons/uil-check';
import UilComment from '@iconscout/react-unicons/icons/uil-comment';
import UilCommentCheck from '@iconscout/react-unicons/icons/uil-comment-check';
import UilComments from '@iconscout/react-unicons/icons/uil-comments';
import UilCommentSlash from '@iconscout/react-unicons/icons/uil-comment-slash';
import UilDownload from '@iconscout/react-unicons/icons/uil-download-alt';
import UilDownloadCloud from '@iconscout/react-unicons/icons/uil-cloud-download';
import UilDownloadImage from '@iconscout/react-unicons/icons/uil-image-download';
import UilDraggabledots from '@iconscout/react-unicons/icons/uil-draggabledots';
import UilEllipsisH from '@iconscout/react-unicons/icons/uil-ellipsis-h';
import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import UilExclamationCircle from '@iconscout/react-unicons/icons/uil-exclamation-circle';
import UilExclamationOctagon from '@iconscout/react-unicons/icons/uil-exclamation-octagon';
import UilExchange from '@iconscout/react-unicons/icons/uil-exchange';
import UilExternalLink from '@iconscout/react-unicons/icons/uil-external-link-alt';
import UilExport from '@iconscout/react-unicons/icons/uil-export';
import UilEye from '@iconscout/react-unicons/icons/uil-eye';
import UilEyeSlash from '@iconscout/react-unicons/icons/uil-eye-slash';
import UilGraduationCap from '@iconscout/react-unicons/icons/uil-graduation-cap';
import UilGrids from '@iconscout/react-unicons/icons/uil-grids';
import UilHistory from '@iconscout/react-unicons/icons/uil-history';
import UilImageBroken from '@iconscout/react-unicons/icons/uil-image-broken';
import UilImport from '@iconscout/react-unicons/icons/uil-import';
import UilInfoCircle from '@iconscout/react-unicons/icons/uil-info-circle';
import UilLightbulbAlt from '@iconscout/react-unicons/icons/uil-lightbulb-alt';
import UilLinkAlt from '@iconscout/react-unicons/icons/uil-link-alt';
import UilLock from '@iconscout/react-unicons/icons/uil-lock';
import UilMap from '@iconscout/react-unicons/icons/uil-map';
import UilMapMarker from '@iconscout/react-unicons/icons/uil-map-marker';
import UilMapPin from '@iconscout/react-unicons/icons/uil-map-pin';
import UilMessage from '@iconscout/react-unicons/icons/uil-message';
import UilNewspaper from '@iconscout/react-unicons/icons/uil-newspaper';
import UilPaperClip from '@iconscout/react-unicons/icons/uil-paperclip';
import UilPen from '@iconscout/react-unicons/icons/uil-pen';
import UilQuestionCircle from '@iconscout/react-unicons/icons/uil-question-circle';
import UilRepeat from '@iconscout/react-unicons/icons/uil-repeat';
import UilSchedule from '@iconscout/react-unicons/icons/uil-schedule';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import UilSetting from '@iconscout/react-unicons/icons/uil-setting';
import UilShare from '@iconscout/react-unicons/icons/uil-share';
import UilSort from '@iconscout/react-unicons/icons/uil-sort';
import UilSortAmountDown from '@iconscout/react-unicons/icons/uil-sort-amount-down';
import UilSortAmountUp from '@iconscout/react-unicons/icons/uil-sort-amount-up';
import UilSync from '@iconscout/react-unicons/icons/uil-sync';
import UilSyncExclamation from '@iconscout/react-unicons/icons/uil-sync-exclamation';
import UilSyncSlash from '@iconscout/react-unicons/icons/uil-sync-slash';
import UilTachometerFastAlt from '@iconscout/react-unicons/icons/uil-tachometer-fast-alt';
import UilUpload from '@iconscout/react-unicons/icons/uil-upload';
import UilUploadCloud from '@iconscout/react-unicons/icons/uil-cloud-upload';
import UilUploadImage from '@iconscout/react-unicons/icons/uil-image-upload';
import UilUser from '@iconscout/react-unicons/icons/uil-user';
import UilUserTimes from '@iconscout/react-unicons/icons/uil-user-times';
import UilUserExclamation from '@iconscout/react-unicons/icons/uil-user-exclamation';
import UilUserCheck from '@iconscout/react-unicons/icons/uil-user-check';
import UilUserPlus from '@iconscout/react-unicons/icons/uil-user-plus';
import UilUserMinus from '@iconscout/react-unicons/icons/uil-user-minus';
import UilUsers from '@iconscout/react-unicons/icons/uil-users-alt';
import UilTag from '@iconscout/react-unicons/icons/uil-tag';
import UilTh from '@iconscout/react-unicons/icons/uil-th';
import UilTimes from '@iconscout/react-unicons/icons/uil-times';
import UilTimesCircle from '@iconscout/react-unicons/icons/uil-times-circle';
import UilTrash from '@iconscout/react-unicons/icons/uil-trash';
import UilVideo from '@iconscout/react-unicons/icons/uil-video';

// ICONSCOUT React Unicons Solid UIL
import UisBookmark from '@iconscout/react-unicons-solid/icons/uis-bookmark';
import UisStar from '@iconscout/react-unicons-solid/icons/uis-star';

export const Unicons = {
  Apps: UilApps,
  Analysis: UilAnalysis,
  Analytics: UilAnalytics,
  Archive: UilArchive,
  ArrowChartDown: UilChartDown,
  ArrowDown: UilArrowDown,
  ArrowLeft: UilArrowLeft,
  ArrowRight: UilArrowRight,
  ArrowUp: UilArrowUp,
  Asterisk: UilAsterisk,
  Award: UilAward,
  Bars: UilBars,
  Bolt: UilBolt,
  Book: UilBook,
  Bookmark: UilBookmark,
  BookmarkS: UisBookmark,
  Broken: UilImageBroken,
  // Calendar: UilCalendar,
  CalendarSlash: UilCalendarSlash,
  Close: UilTimes,
  Comment: UilComment,
  CommentCheck: UilCommentCheck,
  Comments: UilComments,
  CommentSlash: UilCommentSlash,
  Circle: UilCircle,
  CircleCheck: UilCheckCircle,
  CircleExclamation: UilExclamationCircle,
  CircleQuestion: UilQuestionCircle,
  CircleInfo: UilInfoCircle,
  CircleMinus: UilMinusCircle,
  CircleTimes: UilTimesCircle,
  Check: UilCheck,
  Clock: UilClock,
  Crosshair: UilCrosshair,
  Crosshairs: UilCrosshairs,
  Download: UilDownload,
  DownloadCloud: UilDownloadCloud,
  DownloadImage: UilDownloadImage,
  Draggable: UilDraggabledots,
  EllipsisH: UilEllipsisH,
  EllipsisV: UilEllipsisV,
  Eye: UilEye,
  EyeSlash: UilEyeSlash,
  Exchange: UilExchange,
  Export: UilExport,
  ExternalLink: UilExternalLink,
  GraduationCap: UilGraduationCap,
  Grids: UilGrids,
  History: UilHistory,
  Import: UilImport,
  Lightbulb: UilLightbulbAlt,
  Link: UilLinkAlt,
  Lock: UilLock,
  Map: UilMap,
  MapMarker: UilMapMarker,
  MapPin: UilMapPin,
  Message: UilMessage,
  Newspaper: UilNewspaper,
  OctagonExclamation: UilExclamationOctagon,
  PaperClip: UilPaperClip,
  Pen: UilPen,
  Repeat: UilRepeat,
  Schedule: UilSchedule,
  Search: UilSearch,
  Setting: UilSetting,
  Share: UilShare,
  Sort: UilSort,
  SortAmountDown: UilSortAmountDown,
  SortAmountUp: UilSortAmountUp,
  StarS: UisStar,
  Sync: UilSync,
  SyncExclamation: UilSyncExclamation,
  SyncSlash: UilSyncSlash,
  Tachometer: UilTachometerFastAlt,
  Upload: UilUpload,
  UploadCloud: UilUploadCloud,
  UploadImage: UilUploadImage,
  User: UilUser,
  UserTimes: UilUserTimes,
  UserExclamation: UilUserExclamation,
  UserCheck: UilUserCheck,
  UserPlus: UilUserPlus,
  UserMinus: UilUserMinus,
  Users: UilUsers,
  Tag: UilTag,
  Th: UilTh,
  Trash: UilTrash,
  Video: UilVideo
};